export const ProfileData = [
  {
    name: "Ayush Jain",
    img: "ayush",
    designation: "Co-Founder COO",
    contactLink: {
      linkedIn: "https://www.linkedin.com/in/ayushjain0510",
      instgram: "https://instagram.com/ayushjain0510?utm_medium=copy_link",
    },
  },
  {
    name: "Aman Tiwari",
    img: "aman",
    designation: "Tech Head",
    contactLink: {
      linkedIn: "https://www.linkedin.com/in/aman-tiwari1/",
    },
  },
  {
    name: "Baalamurgan",
    img: "baala",
    designation: "Senior Developer",
    contactLink: {
      linkedIn: "https://www.linkedin.com/in/baalamurgan/",
      instgram: "https://www.instagram.com/baalamurgan?utm_medium=copy_link",
    },
  },
];
